<template>
  <template v-if="canvas?.rows">
    <template v-for="row in canvas.rows" :key="row.id">
      <Row v-if="Object.keys(row).length" :row="row" />
    </template>
    <AtomicUiSlideout
      :id="slideoutId"
      :title="slideoutStack[0]?.title"
      :backable="slideoutStack[0]?.backable"
      @back-slideout="backSlide"
      @close-slideout="resetSlideout"
    >
      <component :is="slideoutStack[0]?.component" v-if="slideoutStack[0]?.component" v-bind="slideoutStack[0]?.props" />
    </AtomicUiSlideout>
  </template>
</template>
<script setup>
import { onMounted, ref, computed } from 'vue';
import Row from '~/components/canvas/row.vue';
import * as a from '~/utils/UserStatus';
import { useWalletStore } from '../../stores/wallet';
import { Cookie } from '@vue-util/cookie';
const { canvas } = defineProps({ canvas: { type: Object, default: () => ({ rows: [] }) } });
const walletStore = useWalletStore();
const slideoutStack = computed(() => walletStore.slideoutStack);
const slideoutId = ref('my-wallet-slideout');
function backSlide() {
  walletStore.slideoutStack.shift();
}
function resetSlideout() {
  walletStore.resetSlideout();
}
onMounted(async () => {
  const miscGcs = a.getCookie('MISCGCs');
  const uid = Cookie.get('macys_online_uid');
  const secureToken = Cookie.get('secure_user_token');
  const signedInRaw = Cookie.get('SignedIn');
  const signedIn = signedInRaw ? 1 : 0;
  if (uid && miscGcs !== false) {
    const headers = {
      accept: 'application/json',
      'X-Macys-SecurityToken': secureToken || '',
      'X-Macys-UID': uid || '',
      SignedIn: signedIn,
    };
    await walletStore.getCustomerOffers({ uid, headers });
  }
});
</script>
<style></style>
